import { Component } from '@verndale/core';
import { breakpoints } from '../helpers/constants';
import { throttle, debounce } from '../helpers';

class EventListingHero extends Component {
  setupDefaults() {
    this.dom = {
      el: this.el,
      lineDesktop: this.el.querySelector(
        '.event-listing-hero__red-line-desktop'
      ),
      lineMobile: this.el.querySelector('.event-listing-hero__red-line-mobile'),
      mediaImage: this.el.querySelector('.event-listing-hero__image')
    };

    this.breakpoint = window.matchMedia(
      `(min-width: ${breakpoints.tabletLandscape}px)`
    );

    this.lineAnimation();
  } // setupDefaults

  addListeners() {
    window.addEventListener(
      'scroll',
      throttle(this.lineAnimation.bind(this), 5)
    );

    window.addEventListener(
      'resize',
      debounce(this.lineAnimation.bind(this), 200)
    );
  } // addListeners

  lineAnimation() {
    this.lineDesktopAnimation();
    this.lineMobileAnimation();
  }

  lineDesktopAnimation() {
    if (!this.breakpoint.matches) {
      return;
    }

    const { lineDesktop, el } = this.dom;

    if (!el || !lineDesktop) {
      return;
    }

    const blockRect = el.getBoundingClientRect();
    let scrollPos = blockRect.top - 100;
    const blockHeight = blockRect.height;

    if (scrollPos > 0) {
      scrollPos = 0;
    }

    scrollPos = Math.abs(scrollPos);

    const scrollPercent = (scrollPos / blockHeight) * 150;

    const minHeight = 0;
    const maxHeight = 100;

    if (scrollPercent < minHeight) {
      lineDesktop.style.height = `${minHeight}%`;
    } else if (scrollPercent > maxHeight) {
      lineDesktop.style.height = `${maxHeight}%`;
    } else {
      lineDesktop.style.height = `${scrollPercent}%`;
    }
  } // lineDesktopAnimation

  lineMobileAnimation() {
    if (this.breakpoint.matches) {
      return;
    }

    const { lineMobile, el, mediaImage } = this.dom;

    if (!el || !lineMobile) {
      return;
    }

    let scrollPos = el.getBoundingClientRect().top;

    if (scrollPos > 0) {
      scrollPos = 0;
    }

    scrollPos = Math.abs(scrollPos);

    const windowHeight = window.innerHeight;
    const scrollPercent = (scrollPos / windowHeight) * 175;
    const minHeight = 0;
    const maxHeight = 110;

    if (scrollPercent < 0) {
      lineMobile.style.height = `${minHeight}%`;
    } else if (scrollPercent > maxHeight) {
      lineMobile.style.height = `${maxHeight}%`;
    } else {
      lineMobile.style.height = `${scrollPercent}%`;
    }
  } // lineMobileAnimation
} // EventListingHero

export default EventListingHero;
